import { getLocalizedName } from '../../lib/localization'

// Re-exported so the contract-types page and editor share the exact same
// document-type label logic as the folder-layout editor, instead of a second
// copy that could drift.
export { documentTypeDisplayName } from '../folder-layouts/display-names'

/**
 * Display helper for the contract-types hierarchy editor, mirroring
 * `folderDisplayName` in `folder-layouts/display-names.ts`.
 *
 * `locale` is a parameter, not a hook call, because this runs inside
 * `useMemo`s — callers read it once via `useLocale()` and must list it in the
 * memo dependency array so a language switch re-labels the UI immediately.
 */
export function contractTypeDisplayName(
    contractType: { names?: { [key: string]: string } | null },
    locale: string
): string {
    return getLocalizedName(contractType.names, locale) || 'Unnamed'
}
